module.exports = __webpack_public_path__ + "static/media/06jiechuwanggong.3e485b53.png";